module.exports = __webpack_public_path__ + "img/kommune-434.7a50c3ac.svg";